<template>
	<div class="about">
		<button @click="getAlbum">Get Album</button>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				client_id: '95e5bd2d9d794956a426ac60aea4a399',
				client_secret: 'c71960e9c60c444990a69f3fa8f718a3',
				access_token: 'AQBacp8tMRj7HZior02RSITuIfcWJMsW_UJMsqC1N-IsavE9cFlTvcOX-y_6YeRVy9QAU19gk8yCAQcSe75O83z6ZVRY0W7aYzWHC9uIWb2ivrTAMuOWxmUTam67ldsLyz_7VHCMhCL5V3KKildy6l0Olb0ZBRkqre0QmjVTfcI6bRTOxox5hcNGo6KH0gW_GX9JMU0NROVS-XPo7QtSvcfyewv6qkURxXKgJ2ZFx1jvsECs-V7SNgfU6JXgkldVusFWp88weA',
				topTracksData: [],
				mostPlays: null,
				fewestPlays: null,
			}
		},
		mounted() {
			// this.getAlbum();
			// return;
			// console.log();

		}
	}
</script>
